import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/close_icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-79a8e5d1")

_pushScopeId("data-v-79a8e5d1")
const _hoisted_1 = { class: "recommend-food-notice-toast" }
const _hoisted_2 = {
  key: 0,
  class: "recommend-food-notice-toast-view"
}
const _hoisted_3 = {
  class: "recommend-food-notice-toast-view-card",
  ref: "cardContent"
}
const _hoisted_4 = { class: "recommend-food-notice-toast-view-card-message" }
const _hoisted_5 = { class: "recommend-food-notice-toast-view-card-message-text" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "recommend-food-notice-toast-view-card-button-image",
  src: _imports_0
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isShowToast)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.message), 1)
            ]),
            _createVNode("div", {
              class: "recommend-food-notice-toast-view-card-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickClose(...args)))
            }, [
              _hoisted_6
            ])
          ], 512)
        ]))
      : _createCommentVNode("", true)
  ]))
})